module.exports = __webpack_public_path__ + "img/30.291e5db5.jpeg";